import React, { useEffect, useRef } from "react"
import styled from "styled-components"
import { AppFunctionComponent } from "../../../../types"
import MobileSubscriptionsChartSVG from "../../../../images/mobile-subscriptions-chart.inline.svg"

interface ChartSVGProps {
  circleActiveIndex: number
}

const ChartSVG = styled(MobileSubscriptionsChartSVG)<ChartSVGProps>`
  width: 100%;
  height: 100%;

  circle {
    fill: ${({ theme }) => theme.color.chartCircleFill};
    transition: fill 0.5s;
    cursor: pointer;

    &:hover {
      fill: ${({ theme }) => theme.color.chartCircleHover};
    }
  }

  circle.active {
    fill: ${({ theme }) => theme.color.chartCircleActive};
    cursor: auto;
  }
`

interface Props {
  activeCircleIndex: number
  onActiveCircleIndexChange: (index: number) => void
}

const Chart: AppFunctionComponent<Props> = ({
  className,
  activeCircleIndex,
  onActiveCircleIndexChange,
}) => {
  const circlesOrder = useRef<SVGCircleElement[]>([])
  const ref = useRef<HTMLDivElement>(null)

  const toggleActiveClass = (index: number) => {
    circlesOrder.current.forEach((circleOrder) =>
      circleOrder.classList.remove("active")
    )
    const circle = circlesOrder.current[index]
    circle?.classList.add("active")
  }

  useEffect(() => {
    const svgNode = ref.current && ref.current.querySelector("svg")

    if (svgNode) {
      circlesOrder.current = Array.from<SVGCircleElement>(
        svgNode.querySelectorAll("circle")
      ).sort((a, b) => {
        return Number(a.getAttribute("cx")) - Number(b.getAttribute("cx"))
      })
    }
  }, [ref])

  useEffect(() => {
    toggleActiveClass(activeCircleIndex)
  }, [activeCircleIndex])

  const handleCircleNodeClick = ({ target }: { target: SVGElement }) => {
    if (target.nodeName === "circle") {
      const circleIndex = circlesOrder.current.findIndex(
        (element) => element === target
      )
      toggleActiveClass(circleIndex)
      onActiveCircleIndexChange(circleIndex)
    }
  }

  return (
    <div className={className} ref={ref}>
      <ChartSVG onClick={handleCircleNodeClick} />
    </div>
  )
}

export default Chart
